import { jsx as _jsx } from "react/jsx-runtime";
import { MathJax } from 'better-react-mathjax';
import { useEffect, useRef } from 'react';
export var Fraction = function (props) {
    var denominator = props.denominator, numerator = props.numerator, integer = props.integer;
    if (integer == undefined || integer == 0) {
        return _jsx(MathJax, { tabIndex: -1, children: "\\(\\frac{".concat(numerator, "}{").concat(denominator, "}\\)") });
    }
    if (denominator == 0)
        return _jsx(MathJax, { tabIndex: -1, children: "".concat(numerator, " ") });
    return _jsx(MathJax, { tabIndex: -1, children: "".concat(integer, " \\(\\frac{").concat(numerator, "}{").concat(denominator, "}\\)") });
};
export var MathJaxWrapper = function (props) {
    var ref = useRef(null);
    var children = props.children;
    useEffect(function () {
        var changeTabIndex = function () {
            var _a;
            var _container = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('mjx-container');
            if (_container && _container.length > 0) {
                Array.from(_container).forEach(function (element) {
                    element.setAttribute('tabindex', '-1');
                    element.setAttribute('aria-hidden', 'true');
                });
                if (_container[0].parentElement &&
                    _container[0].parentElement.tagName.toLowerCase() == 'span')
                    _container[0].parentElement.setAttribute('aria-hidden', 'true');
            }
        };
        setTimeout(function () { return changeTabIndex(); }, 1000);
        // Cleanup MathJax elements on unmount to prevent memory leaks
        return function () {
            if (ref.current) {
                // Remove all MathJax container elements
                var containers = ref.current.getElementsByTagName('mjx-container');
                Array.from(containers).forEach(function (element) {
                    if (element.parentNode) {
                        element.parentNode.removeChild(element);
                    }
                });
                // Clear the container's children
                while (ref.current.firstChild) {
                    ref.current.removeChild(ref.current.firstChild);
                }
            }
        };
    }, [children, ref.current]);
    return typeof children == 'string' && children.startsWith('\\(') ? (_jsx("div", { className: "fractionText", ref: ref, children: _jsx(MathJax, { children: children }) })) : (children);
};
